import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SignupComponent } from './home-components/signup/signup.component';
import { LoginComponent } from './home-components/login/login.component';
import { FooterComponent } from './home-components/footer/footer.component';
import { MaterialModule } from '../material-module';
import { AboutUsComponent } from './home-components/about-us/about-us.component';
import { ServicesComponent } from './home-components/services/services.component';
import { ContactUsComponent } from './home-components/contact-us/contact-us.component';
import { ForgotPasswordComponent } from './home-components/forgot-password/forgot-password.component';
import { HeaderComponent } from './home-components/header/header.component';
import { VerifyEmailComponent } from './home-components/verify-email/verify-email.component';
import { VerifyComponent } from './home-components/verify/verify.component';
import { PasswordChangedComponent } from './home-components/password-changed/password-changed.component';
import { EnterNewPasswordComponent } from './home-components/enter-new-password/enter-new-password.component';
import { ExpiredPasswordLinkComponent } from './home-components/expired-password-link/expired-password-link.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BannerComponent } from './home-components/banner/banner.component';
import { PageNotFoundComponent } from './home-components/page-not-found/page-not-found.component';
import { ServicesGreenCardComponent } from './home-components/services-green-card/services-green-card.component';
import { SharedModule } from "../shared/shared.module";



@NgModule({
    declarations: [
        HomeComponent,
        SignupComponent,
        LoginComponent,
        FooterComponent,
        AboutUsComponent,
        ServicesComponent,
        ContactUsComponent,
        ForgotPasswordComponent,
        HeaderComponent,
        VerifyEmailComponent,
        VerifyComponent,
        PasswordChangedComponent,
        EnterNewPasswordComponent,
        ExpiredPasswordLinkComponent,
        BannerComponent,
        PageNotFoundComponent,
        ServicesGreenCardComponent,
    ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        MaterialModule,
        FlexLayoutModule,
    ]
})
export class HomeModule { }
